export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12')
];

export const server_loads = [];

export const dictionary = {
		"/policy": [4,[2]],
		"/policy/california": [5,[2]],
		"/policy/privacy": [6,[2]],
		"/policy/tos": [7,[2]],
		"/venues/[venueId]": [8,[3]],
		"/venues/[venueId]/directions": [9,[3]],
		"/venues/[venueId]/directions/[fromType]/[fromId]/[toType]/[toId]": [10,[3]],
		"/venues/[venueId]/directions/[fromType]/[fromId]/[toType]/[toId]/steps": [11,[3]],
		"/venues/[venueId]/locations/[locationId]": [12,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';